import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { config } from '../../shared/smartadmin.config';
import { Observable } from 'rxjs/Observable';
import { Console } from '@angular/core/src/console';

@Injectable()
export class OrdenServicioApiService {
  data: any[] = [];

  ordenServicioURL: string = config.API_DATA_URL + "/ordenservicio";

  constructor(public http: HttpClient) {}

  public getOrdenesServicio(idSucursal: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.ordenServicioURL + "/GetBySucursal/" + idSucursal, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  // public getOrdenesServicioParams(idSucursal: number, ordenServicio: number): Observable<any> {
  //   const headers = this.getHeaders();

  //   return this.http.get(this.ordenServicioURL + '/GetBySucursal/' + idSucursal + '/' + ordenServicio, { headers })
  //   .map( (response: any) => {
  //       this.data = response;
  //       return this.data;
  //     })
  //   .catch(this.handleError)
  // }

  public getOrdenServicioString(
    idSucursal: number,
    ordenServicio: string,
  ): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(
        this.ordenServicioURL +
          "/GetBySucursalOrden/" +
          idSucursal +
          "/" +
          ordenServicio,
        { headers },
      )
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public getOrdenServicio(idSucursal: number, folio: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(
        this.ordenServicioURL +
          "/GetByOrdenServicio/" +
          idSucursal +
          "/" +
          folio,
        { headers },
      )
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public Dashboard(idSucursal: number): Observable<any> {
    const headers = this.getHeaders();
    // let param = JSON.stringify(idSucursal);
    return this.http
      .get(this.ordenServicioURL + "/Dashboard/" + idSucursal, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public ReporteTrabajo(idOrdenServicio: number): Observable<any> {
    const headers = this.getHeaders();
    // let param = JSON.stringify(idSucursal);
    console.log(
      this.ordenServicioURL + "/" + idOrdenServicio + "/GetReporteTrabajo",
    );
    return this.http
      .get(this.ordenServicioURL + "/ReporteTrabajo/" + idOrdenServicio, {
        headers,
      })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  GuardarReporteTrabajo(formData: FormData) {
    return this.http.post(
      this.ordenServicioURL + "/GuardarReporteTrabajo",
      formData,
    );
  }

  LeerPdfsReporteTrabajo(idOrdenServicio: number) {
    return this.http
      .get(this.ordenServicioURL + "/LeerPdfsReporteTrabajo/" + idOrdenServicio)
      .map((response) => response)
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });;
  }

  public LiberarProceso(idOrdenServicio: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(idOrdenServicio);
    return this.http
      .post(this.ordenServicioURL + "/LiberarProceso", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public BuscarOrdenServicio(idSucursal: number, filtro: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(filtro);
    return this.http
      .post(this.ordenServicioURL + "/Buscar/" + idSucursal, param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  private getBaseUrl() {
    return (
      location.protocol +
      "//" +
      location.hostname +
      (location.port ? ":" + location.port : "") +
      "/"
    );
  }

  private getHeaders(): HttpHeaders {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    return headers;
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : "Server error";
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/orden-servicio.service.ts